<template>
  <p>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-if="includeInfoIcon" :class="$style.infoIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#4373c7" fill-rule="evenodd" d="M6.9 3.333c-.544 0-.9-.36-.9-.917a1.1 1.1 0 011.088-1.083c.524 0 .912.367.912.924 0 .62-.506 1.076-1.1 1.076m-2.037 6c-.408 0-.691-.215-.691-.698 0-.614.385-1.657.466-1.872L5.43 4.52c.08-.232-.022-.346-.113-.346-.418 0-.964 1.11-1.168 1.11-.08 0-.15-.09-.15-.167 0-.227.504-.764.648-.93.456-.484 1.045-.854 1.7-.854.487 0 1.012.334.6 1.569l-.815 2.481c-.07.191-.193.513-.193.716 0 .09.048.179.14.179.337 0 .958-1.086 1.12-1.086.058 0 .133.078.133.191 0 .37-1.323 1.95-2.47 1.95m6.332-6.345A5.973 5.973 0 009.012.805 5.868 5.868 0 006 0a5.868 5.868 0 00-3.012.805A5.973 5.973 0 00.805 2.988 5.871 5.871 0 000 6a5.87 5.87 0 00.805 3.012 5.974 5.974 0 002.183 2.184A5.87 5.87 0 006 12a5.87 5.87 0 003.012-.804 5.974 5.974 0 002.183-2.184C11.732 8.092 12 7.089 12 6a5.869 5.869 0 00-.805-3.012"/></svg>
    {{ infoText }}
    <LinkExternal
      :href="kbLink"
    >
      {{ kbText }}
    </LinkExternal>
  </p>
</template>

<script>
import LinkExternal from 'client/components/Links/LinkExternal.vue';

export default {
  name: 'KnowledgeBaseArticle',

  components: {
    LinkExternal,
  },

  props: {
    includeInfoIcon: {
      default: true,
      type: Boolean,
    },
    infoText: {
      required: true,
      type: String,
    },
    kbLink: {
      required: true,
      type: String,
    },
    kbText: {
      type: String,
      default: 'Knowledge Base article',
    },
  },
};
</script>
<style module>
.infoIcon {
  display: inline-block;
  height: 15px;
  margin-right: 5px;
  vertical-align: middle;
  width: 15px;
}
</style>
